import { Stack, Heading, Box } from "@chakra-ui/layout";
import { useColorModeValue } from "@chakra-ui/color-mode";
import { layerStyle, textStyle, radius } from "theme/names";

interface Props {
  title?: string;
  description?: any;
  mt?: number;
  children: React.ReactNode;
  css?: any;
}

export function CustomSection({ title, description, children, mt = 10, css = {} }: Props) {
  return (
    <Box
      p={[4, 8]}
      layerStyle={layerStyle["bg.border.rounded"]}
      borderRadius={radius.lg}
      overflow="auto"
    >
      <Stack {...css}>
        {title && <Box textStyle={textStyle["h3.bold.standard"]}>
          {title}
        </Box>}
        {description && (
          <Box textStyle={textStyle["body.medium.light"]} maxW="600px">
            {description}
          </Box>
        )}
        {children}
      </Stack>
    </Box>
  );
}
